<div class="d-flex flex-column w-100">
	<div class="d-flex flex-fill">
		<span class="p-float-label mt-4 w-100">
			<textarea
				pInputTextarea
				#canvasSubscriptionDescription
				name="canvasSubscriptionDescription"
				[(ngModel)]="venueService.ooCanvases[canvasIndex].subscriptionDescription"
				class="w-100 mt-1"
			></textarea>
			<label for="canvasSubscriptionDescription">Subscription Description</label>
		</span>
	</div>
</div>
<div class="d-flex flex-column mt-2 w-100">
	<div class="h4">Subscription Items</div>
	<app-canvas-subscription-items-list [canvasIndex]="canvasIndex"></app-canvas-subscription-items-list>
</div>
